module.exports = __webpack_public_path__ + "img/aircon_cool_on_border.cc3a6685.png";